import {useLayoutEffect} from 'react';

/** UserCenter uses real CSS pixels, even when opened from the scaled game. */
export function useUserCenterViewport(mobile:boolean) {
  useLayoutEffect(()=>{
    if(!mobile)return;
    const root=document.documentElement;
    let meta=document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
    const created=!meta;
    if(!meta){meta=document.createElement('meta');meta.name='viewport';document.head.appendChild(meta);}
    const original=meta.content,previousHeight=root.style.getPropertyValue('--uc-visible-height');
    meta.content='width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover';
    const resize=()=>{
      const viewport=window.visualViewport;
      const height=viewport ? viewport.height*viewport.scale : window.innerHeight;
      if(height>0)root.style.setProperty('--uc-visible-height',`${Math.round(height)}px`);
    };
    let focusTimer:ReturnType<typeof setTimeout>;
    const focus=(event:FocusEvent)=>{
      const target=event.target;
      if(!(target instanceof HTMLElement)||!target.closest('.uc-page')||!target.matches('input,textarea,select'))return;
      clearTimeout(focusTimer);
      focusTimer=setTimeout(()=>{resize();target.scrollIntoView?.({block:'center',inline:'nearest'});},250);
    };
    resize();window.addEventListener('resize',resize);window.addEventListener('orientationchange',resize);
    window.visualViewport?.addEventListener('resize',resize);document.addEventListener('focusin',focus);
    return()=>{
      clearTimeout(focusTimer);window.removeEventListener('resize',resize);window.removeEventListener('orientationchange',resize);
      window.visualViewport?.removeEventListener('resize',resize);document.removeEventListener('focusin',focus);
      if(created)meta!.remove();else meta!.content=original;
      if(previousHeight)root.style.setProperty('--uc-visible-height',previousHeight);else root.style.removeProperty('--uc-visible-height');
    };
  },[mobile]);
}
